import React from "react";
import { Helmet } from "react-helmet";

function Title({ title, drive }) {
  return (
    <Helmet>
      <title>{drive ? title : `${title} - BrightSign`}</title>
      <meta name="description" content={`${title} - BrightSign`} />
    </Helmet>
  );
}

export default Title;
